//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

export default {
  name: 'ViuButton',
  props: {
    /**
     * Deshabilitar el botón
     */
    disabled: Boolean,
    /**
     * Dejar en modo 'active' el botón
     */
    enabled: Boolean,
    /**
     * Seleccionar un patrón de color de los establecidos
     * @values solid, outline
     */
    fill: {
      type: String,
      default: 'solid'
    },
    /**
     * Seleccionar el tamaño del botón
     * @values medium, small, row
     */
    size: {
      type: String,
      default: 'medium'
    },
    /**
     * Establecer clases en elemento donde lanza los eventos para testing QA
     */
    dusk: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    version
  }),
  methods: {
    /**
     * Method que emite el click al padre.
     */
    onClick() {
      if (!this.disabled) {
        this.$emit('click', {
          clicked: true,
          fill: this.fill,
          disabled: this.disabled
        });
      }
    }
  }
};
